import React, {Component, Fragment} from 'react';
import FuseTheme from '../global/theme';
import {commonStyles} from '../shared/styles';
import RaisedButton from 'material-ui/RaisedButton';

const styles = {
    tableHeaderTitle: {
        position: 'relative',
        backgroundColor: FuseTheme.palette.accent2Color,
        color: FuseTheme.palette.textColor,
        fontWeight: '400',
        margin: 0,
        padding: '0.25em 0.5em'
    },
    wrapText: {wordWrap: 'break-word'},
    btnContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginTop: 10
    }
};

class DialogInventoryOrderConfirm extends Component {
    render() {
        const {
            data,
            onSubmit,
            onCancel,
            action = 'delete',
            type = 'product'
        } = this.props;

        const handleSubmit = () => {
            if (typeof onSubmit === 'function') {
                onSubmit(action, type, data);
            }
        };

        const handleCancel = () => {
            if (typeof onCancel === 'function') {
                onCancel(action, type);
            }
        };

        const locationId = (data.location_id) ? data.location_id : '';
        const productId = (data.cs_product_id) ? data.cs_product_id : '';
        const productName = (data.product_name) ? data.product_name : '';
        let submitText = 'Submit';
        if (type === 'order') {
            submitText = (action === 'delete') ? 'Delete Order' : 'Generate Order';
        }
        if (type === 'product' && action === 'delete') {
            submitText = (action === 'delete') ? 'Remove Product from Order' : 'Approve';
        }

        return (
            <div className="dialog-content-container">
                <div className="reports-table-title" style={styles.tableHeaderTitle}>
                    <h3 style={styles.tableHeaderTitle}>
                        {action === 'delete' &&
                            <Fragment>
                                {type === 'order' &&
                                    <Fragment>
                                        Delete Order
                                    </Fragment>
                                }
                                {type === 'product' &&
                                    <Fragment>
                                        Remove Product from Order
                                    </Fragment>
                                }
                            </Fragment>
                        }
                        {action === 'submit' &&
                            <Fragment>
                                {type === 'order' &&
                                    <Fragment>
                                        Generate order for {(locationId) ? 'Location ' + locationId : 'this Location'}
                                    </Fragment>
                                }
                            </Fragment>
                        }
                    </h3>
                </div>
                {action === 'delete' &&
                    <Fragment>
                        {type === 'order' &&
                            <Fragment>
                                <p>
                                    Are you sure you want to delete this order
                                    for {(locationId) ? 'Location ' + locationId : 'this Location'}?
                                </p>
                                <p>
                                    Once Order is deleted, you will be returned to the Inventory Orders list.
                                </p>
                            </Fragment>
                        }
                        {type === 'product' &&
                            <Fragment>
                                <p>
                                    Are you sure you want to
                                    remove {(productId) ? 'Product ' + productId : 'this Product'}
                                    {(productName) ? ' - "' + productName + '"' : ''} from
                                    this order?
                                </p>
                            </Fragment>
                        }
                    </Fragment>
                }
                {action === 'submit' &&
                    <Fragment>
                        {type === 'order' &&
                            <Fragment>
                                <p>
                                    Are you sure you want to generate an order
                                    for {(locationId) ? 'Location ' + locationId : 'this Location'}?
                                </p>
                                <p>
                                    Once Order is approved, it will be sent to the system for processing; you will
                                    be returned to the Inventory Orders list.
                                </p>
                            </Fragment>
                        }
                    </Fragment>
                }

                <div style={styles.btnContainer}>
                    <RaisedButton
                        primary
                        type="button"
                        label={submitText}
                        onClick={() => handleSubmit()}
                        style={commonStyles.buttonInlineRight}
                    />
                    <RaisedButton
                        type="button"
                        label="Cancel"
                        onClick={() => handleCancel()}
                        style={commonStyles.buttonInlineRight}
                    />
                </div>
            </div>
        );
    }
}

export default DialogInventoryOrderConfirm;



// WEBPACK FOOTER //
// ./src/Fuse/components/DialogInventoryOrderConfirm.js